import React, { useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoCall, IoPersonCircle } from "react-icons/io5";
import cn from "../../lib/cn";
import { envelopeClosed } from "../../resources/js/icons";
import P from "../../shared/typography/P";

const SalesExecutiveDetails = ({ onClose, assignee }) => {
    const [showEsclation, setShowEsclation] = useState(false);
    return (
        <div>
            <div
                className="flex md:hidden items-center gap-1"
                role="button"
                onClick={onClose}
            >
                <P>
                    <FaArrowLeftLong />
                </P>
                <P>Go Back</P>
            </div>
            <div className="flex flex-wrap  gap-3 items-stretch  my-2">
                <div className="w-full ">
                    <div className="bg-gray-230 w-full px-1 py-0.5 rounded-lg">
                        <p className="text-primary text-sm font-medium">
                            My Sales Executive
                        </p>
                    </div>
                    <div className="flex items-center gap-2 mt-3 mb-2">
                        <div className="text-7xl text-black">
                            <IoPersonCircle />
                        </div>
                        <div>
                            <P className="font-medium">{assignee?.name}</P>
                            <p className="text-xs text-primary">
                                {assignee?.designation}
                            </p>
                        </div>
                    </div>
                    <div className="flex gap-1 items-center">
                        <div className="bg-gray-170 p-1 rounded-lg">
                            <div className="flex items-center gap-1 mb-0.5">
                                <img
                                    src={envelopeClosed}
                                    alt="envelope"
                                    className="w-1.5 h-1.5"
                                />
                                Email
                            </div>
                            <p className="text-xs text-primary">
                                {assignee?.email}
                            </p>
                        </div>
                        <div className="bg-gray-170 p-1 rounded-lg w-1/2">
                            <div className="flex items-center gap-1 mb-0.5">
                                <p className="text-xs">
                                    <IoCall />
                                </p>
                                Phone
                            </div>
                            <p className="text-xs text-primary">
                                +{assignee?.phoneNumber}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-gray-50   w-full h-0.1"></div>
                <div className="w-full ">
                    <div
                        className="bg-primary w-full px-1 py-0.5 rounded-lg"
                        role="button"
                        onClick={() => setShowEsclation((prev) => !prev)}
                    >
                        <p className="text-white text-sm font-medium">
                            For Escalation
                        </p>
                    </div>
                    <div
                        className={cn(
                            "bg-gray-200 border-blue-200 rounded-xl py-1 px-0.5 mt-2",
                            {
                                hidden: !showEsclation,
                            }
                        )}
                    >
                        <div className="flex items-center gap-2 ">
                            <div className="text-7xl text-black">
                                <IoPersonCircle />
                            </div>
                            <div>
                                <P className="font-medium">
                                    Pravin Sambhaji Langote
                                </P>
                                <p className="text-xs text-primary">
                                    Co-founder and CEO
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-1 items-center mt-2">
                            <div className="bg-white p-1 rounded-lg">
                                <div className="flex items-center gap-1 mb-0.5">
                                    <img
                                        alt="envelope"
                                        src={envelopeClosed}
                                        className="w-1.5 h-1.5"
                                    />
                                    Email
                                </div>
                                <p className="text-xs text-primary">
                                    pravin@hypersrot.com
                                </p>
                            </div>
                            <div className="bg-white p-1 rounded-lg w-1/2">
                                <div className="flex items-center gap-1 mb-0.5">
                                    <p className="text-xs">
                                        <IoCall />
                                    </p>
                                    Phone
                                </div>
                                <p className="text-xs text-primary">
                                    +91 9730767770
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesExecutiveDetails;
